import { Outlet, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import styles from './styles.module.css';
import { useMenuStore } from '../store/useMenuStore';
import { MenuPageToOverlayMid, MenuPageToShift } from './components/Aside/Aside';

const Main = () => {
    const [isOpen] = useMenuStore((state) => [state.isOpen]);

    let location = useLocation();

    return (
        <>
            <Header />

            <main
                className={`${styles.main} 
                ${
                    MenuPageToOverlayMid.includes(location.pathname)
                        ? styles.overlayMid
                        : !MenuPageToShift.includes(location.pathname)
                          ? styles.overlay
                          : styles.shift
                }
                ${isOpen ? styles.menuOpen : ''}
                `}
            >
                <Outlet />
            </main>
        </>
    );
};

export default Main;
